<template>
<div class="meeting_detail page" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中">
    <top-nav :showWater="showWater"></top-nav>
    <AdvLamu :advCode="'ehqly1098'"></AdvLamu>
    <div class="pw">
        <AdvImage :advCode="'tgfus1099'"></AdvImage>
    </div>
    <Header :showWater="showWater"></Header>
    <column-nav :showWater="showWater"></column-nav>
    <div class="pw">
        <crumbs :arr="crumbs" :showWater="showWater"></crumbs>
        <!--竞投咨询-->
        <!-- <div class="flex" style="z-index: 2; position: relative;">
                <contact :contactData="info"></contact>
                <div class="auctionView"  @click="onlineClick" v-if="isShowOnline">
                    <span class="auctionTitle">在线竞拍 <span v-if="onlinePerson"><span class="line"></span> <i></i>{{onlinePerson}}</span></span>
                </div>
            </div> -->

        <!--广告-->
        <div class="pw">
            <AdvImage :advCode="'kijda275'" :isDD="true" :ddCode="'hidkd984'"></AdvImage>
        </div>
        <!--拍卖相关-->
        <div class="auction-info">
            <el-row :gutter="20" :justify="'space-between'" :align="'middle'" style="margin-left: 0; margin-right: 0;position: relative;z-index: 1;">
                <el-col :span="12" style="padding-left: 0; padding-right: 20px">
                    <div class="grid-content bg-purple ai-box" id="paihu">
                        <div class="big-title">
                            <span class="green-piece"></span>
                            <span class="big-title-font">{{ name }}</span>
                        </div>
                        <div class="gray-title">
                            <span class="gray-title-font">预展信息</span>
                        </div>
                        <div class="ai-info">
                            <template v-for="(item, index) in detailExtraInfo">
                                <p class="ai-info-p" :key="index" v-if="item.name == 'preDate'">
                                    <span class="ai-info-title">时间</span>
                                    <span class="ai-info-font">{{
                                                item.text
                                            }}</span>
                                </p>
                                <p class="ai-info-p" :key="index" v-if="item.name == 'previewPlace'">
                                    <span class="ai-info-title">地点</span>
                                    <span class="ai-info-font">{{
                                                item.text
                                            }}</span>
                                </p>
                            </template>
                        </div>
                        <div class="gray-title">
                            <span class="gray-title-font">拍卖信息</span>
                        </div>
                        <div class="ai-info">
                            <template v-for="(item, index) in detailExtraInfo">
                                <p class="ai-info-p" :key="index" v-if="item.name == 'auctionDate'">
                                    <span class="ai-info-title">时间</span>
                                    <span class="ai-info-font">{{
                                                item.text
                                            }}</span>
                                </p>
                                <p class="ai-info-p" :key="index" v-if="item.name == 'Place'">
                                    <span class="ai-info-title">地点</span>
                                    <span class="ai-info-font">{{
                                                item.text
                                            }}</span>
                                </p>
                            </template>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12" style="padding-left: 0; padding-right: 0">
                    <div class="grid-content bg-purple ai-box" id="compan">
                        <div class="big-title">
                            <span class="green-piece"></span>
                            <span class="big-title-font" @click="jumpLink(arr.WebUrl)">

                                <img v-if="arr.newLogo" :src="arr.newLogo" alt="">
                                {{
                                    arr.Name
                                }}</span>
                        </div>
                        <div class="ai-info">
                            <p class="ai-info-p" v-if="arr.Address">
                                <span class="ai-info-title">地址</span>
                                <span class="ai-info-font">{{
                                        arr.Address
                                    }}</span>
                            </p>
                            <p class="ai-info-p" v-if="arr.PostCode">
                                <span class="ai-info-title">邮编</span>
                                <span class="ai-info-font">{{
                                        arr.PostCode
                                    }}</span>
                            </p>
                            <p class="ai-info-p" v-if="arr.Phone">
                                <span class="ai-info-title">电话</span>
                                <span class="ai-info-font">{{
                                        arr.Phone
                                    }}</span>
                            </p>
                            <p class="ai-info-p" v-if="arr.Fax">
                                <span class="ai-info-title">传真</span>
                                <span class="ai-info-font">{{
                                        arr.Fax
                                    }}</span>
                            </p>
                            <p class="ai-info-p" v-if="arr.Email">
                                <span class="ai-info-title">邮件</span>
                                <span class="ai-info-font"><a :href="'mailto:'+arr.Email">{{ arr.Email }}</a></span>
                            </p>
                            <p class="ai-info-p" v-if="arr.WebUrl">
                                <span class="ai-info-title">网址</span>
                                <span class="ai-info-font"><a :href="(arr.WebUrl.indexOf('https') == -1 && arr.WebUrl.indexOf('http') == -1) ? 'http://'+arr.WebUrl : arr.WebUrl" target="_blank">{{ arr.WebUrl }}</a></span>
                            </p>
                            <p class="ai-info-p" v-if="arr.MiroblogPic">
                                <span class="ai-info-title">公众号</span>
                                <span class="ai-info-font" @mouseenter="showCode = true" @mouseleave="showCode=false">鼠标移入查看微信公众号二维码
                                    <b class="codeBox" v-show="showCode">
                                        <img :src="arr.MiroblogPic" alt=""><br />
                                        打开微信扫一扫<br />扫描二维码
                                    </b>
                                </span>
                            </p>
                            <template v-for="(item,index) in detailInfo">
                                <p class="ai-info-p" v-if="item.type == 'license'" @click="openLicense(item)" style="cursor: pointer;" :key="index">
                                    <span class="ai-info-title">{{ item.label }}</span>
                                    <span class="ai-info-font">{{ item.text }}<i style="margin-left: 10px;color: #949596;" class="el-icon-arrow-right"></i></span>
                                </p>
                            </template>

                        </div>
                    </div>
                </el-col>
            </el-row>
            <!-- 广告 -->
            <el-row v-if="bulletin">
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark ai-box1">
                        <div class="big-title">
                            <span class="green-piece"></span>
                            <span class="big-title-font">公告</span>
                        </div>
                        <div class="ai-info-guanggao">
                            <div class="ai-info-font-guanggao" v-if="detailExtraInfo">
                                <p v-html="bulletin"></p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!--专场信息-->
        <div class="special-info">
            <span class="si-title">专场信息（{{
                        specialsList ? specialsList.length : 0
                    }}个）</span>
            <span ref="sheng" class="default" v-show="specialParam.order == 0" @click="defaultClick">日期↑</span>
            <span ref="sheng" class="default si-green" v-show="specialParam.order == 3" @click="ascen">日期↑</span>
            <span ref="jiang" class="default si-green" v-show="specialParam.order == 2" @click="descen">日期↓</span>
            <span class="si-font">LOT号</span>
            <el-input placeholder="请输入lot号" suffix-icon="el-icon-search" v-model="inputLog" class="si-input" @change="gotoSpecial">
            </el-input>
            <span class="si-gray">范围：格式如：0010</span>
        </div>
        <!--直播-->
        <div class="live-info">
            <el-row v-if="specialsList" :gutter="20" style="margin-left: 0; margin-right: 0">
                <el-col v-for="(item, index) in result[currentPage - 1]" :key="index" :span="8" class="el-col-8">
                    <div @click="jumpSpecialC(item)" class="grid-content bg-purple live-box">
                        <div class="live-pic ">
                            <div  class="liveIcon" :style="(item.live_info.bid_status==2)?'padding:0 10px 0  0;':''">
                                <lottie v-if="item.live_info.bid_status==2&&item.live_info.bid_type==1 " class="liveIconSty" :options="heartOptions" :height="18" :width="18" />
                                <lottie v-if="item.live_info.bid_status==2&&item.live_info.bid_type==2  " style="padding: 3px;" class="liveIconSty" :options="heartOptions2" :height="25" :width="25" />
                                <template v-if="item.live_info.bid_status_name">
                                    {{item.live_info.bid_status_name}}
                                </template>
                                <template v-else-if="item.status==1">
                                    待拍卖
                                </template>
                                <template v-else-if="item.status==2">
                                    预展中
                                </template>
                                <template v-else-if="item.status==3">
                                    待预展
                                </template>
                                <template v-else-if="item.status==4">
                                    拍卖中
                                </template>
                                <template v-else-if="item.status==5">
                                    已结拍
                                </template>
                               
                               
                            </div>
                            <div class="imgBox" style="height: 220px;border-radius:12px;">
                                <el-image style="width: 100%; height: 100%;object-fit: cover;" :src="item.coverPicNew" fit="coverPic">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="el-image__error">
                                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                    </div>
                                </el-image>
                            </div>
                            <!-- <template v-if="fromId">
                                    <a href="javasript:;" class="hoverBg">
                                        <div class="live-pic-green" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 2">
                                           正在直播
                                        </div>
                                        <div class="live-pic-black" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 4 && item.live_info.have_review == 1">
                                            直播回放
                                        </div>
                                        <div class="live-pic-black" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 0 || item.live_info.live_status == 1">
                                            即将开播
                                        </div>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="'https://auction.artron.net/live/detail?id='+item.live_info.lives[0].live_id+'&special_id='+item.live_info.special_id" v-if="item.live_info.have_live == 1" class="hoverBg">
                                        <div class="live-pic-green" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 2">
                                          正在直播
                                        </div>
                                        <div class="live-pic-black" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 4 && item.live_info.have_review == 1">
                                            直播回放
                                        </div>
                                        <div class="live-pic-black" v-if="item.live_info.have_live == 1 && item.live_info.live_status == 0 || item.live_info.live_status == 1">
                                            即将开播
                                        </div>
                                    </a>
                                </template> -->
                        </div>
                        <div class="live-little-box">
                            <span class="llb-title">{{
                                            item.name
                                        }}</span>

                            <div class="llb-bubble" v-if="
                                            item.live_info &&
                                            item.live_info.label_list
                                        ">
                                <div class="llb-bubbles" v-for="(k, m) in item.live_info
                                                .label_list" :key="m">
                                    {{k.name}}
                                </div>
                                <!-- <div class="llb-bubbles">视频直播</div>
                                    <div class="llb-bubbles">图文直播</div>
                                    <div class="llb-bubbles">同步拍</div> -->
                            </div>
                            <div class="llb-info-add">
                                <!-- <template v-for="(m,i) in item.pc_extra_info">
                                        <div class="ai-info-p-add" :key="i" v-if="m.type=='total'">
                                            <span class="llb-info-title">{{m.label}}：</span>
                                            <span class="ai-info-font-adress">{{m.text}}</span>
                                        </div>
                                    </template> -->

                                <template v-for="(m,i) in item.extraInfo">
                                    <div class="ai-info-p-add" :key="i" v-if="m.picUrl=='listicon_lot'">
                                        <span class="llb-info-title"></span>
                                        <span class="ai-info-font-adress">{{m.text}}&nbsp;

                                            <template v-for="itemk in item.pc_extra_info">
                                                <template v-if="itemk.label=='拍品总数'">
                                                    ({{itemk.text}}件)
                                                </template>
                                            </template></span>
                                    </div>
                                </template>
                                <template v-for="(m,i) in item.extraInfo">
                                    <div class="ai-info-p-add" :key="i" v-if="m.picUrl=='listicon_date'">
                                        <span class="llb-info-title"></span>
                                        <span class="ai-info-font-adress">{{m.text}}</span>
                                    </div>
                                </template>
                                <template v-if="item.status == 5">
                                    <template v-for="(m,i) in item.pc_extra_info">
                                        <template v-if="m.label=='总成交'">
                                            <div class="ai-info-p-add" :key="i" v-if="m.text">
                                                <span class="llb-info-title" style="color: #000;">成交总额：</span>
                                                <span class="ai-info-font-adress" style="color: #000;">{{m.text}}
                                                </span>
                                            </div>
                                        </template>
                                    </template>
                                    <!-- <template v-for="(m,i) in item.pc_extra_info">
                                        <template v-if="m.label=='拍品总数'">
                                            <div class="ai-info-p-add" v-if="m.text" :key="i">
                                                <span class="llb-info-title" style="color: #000;" >拍品数量：</span>
                                                <span class="ai-info-font-adress" style="color: #000;" >{{m.text}}
                                                </span>
                                            </div>
                                        </template>
                                    </template> -->
                                </template>
                                <!-- <template v-for="(m,i) in item.extraInfo">
                                        <div class="ai-info-p-add" :key="i" v-if="m.picUrl=='listicon_address'">
                                            <span class="llb-info-title">拍卖地点：</span>
                                            <span class="ai-info-font-adress">{{m.text}}</span>
                                        </div>
                                    </template> -->

                            </div>
                            <!-- <div class="llb-browse">
                                        <span
                                        ><i
                                            class="el-icon-search"
                                            style="
                                                    color: #bfbfbf;
                                                    font-size: 18px;
                                                "
                                        ></i
                                        ></span>
                                    <span class="llb-browse-font"
                                    >快速浏览拍品</span
                                    >
                                </div> -->
                        </div>
                    </div>
                </el-col>
            </el-row>
            <EmptyPage v-else></EmptyPage>
        </div>
        <!--分页-->
        <!-- <div class="paging">
            <el-pagination background :page-size="6" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout=" prev, pager, next" :current-page.sync="jumpVal" :total="specialsList ? specialsList.length : 0" :prev-text="'&lt; 上一页'" :next-text="'下一页 &gt;'">
            </el-pagination>
            <span class="total"><i>{{ currentPage }}</i>/{{
                        specialsList ? Math.ceil(specialsList.length / 6) : 0
                    }}</span>
            <div class="jumpBox">
                跳至
                <input type="text" class="inputJump" v-model="jumpVal" @input="changeNum" />
                页
            </div>
        </div> -->
        <!--拍品推荐-->
        <recomment :session="$route.params.id" :isLogin="isLogin"></recomment>
    </div>
    <copyright :showWater="showWater"></copyright>
    <el-dialog title="提示" :visible="showPop" width="20%" center>
        <span>{{msgTips}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closePop">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog title="" :visible="showLicense" width="50%" show-close close-on-click-modal @close="showLicense=false" center>
        <div class="verifyBox" v-if="!verifyFlag">
            <span>请输入下图的验证码后查看</span>
            <img @click="getGenerate" :src="verifyImg" style="cursor: pointer;"  alt="">
            <span @click="getGenerate" style="color: #009B5F;cursor: pointer;">看不清？换一张</span>
            <el-input class="verifyInput" placeholder="请输入验证码" v-model="verify">
            </el-input>
            <div class="btn" @click="subVerify"  style="cursor: pointer;">确定</div>
        </div>
        <div class="licenseBox" style="margin-top: 0rem;" v-if="verifyFlag">
            <img :src="license" alt="">
        </div>
    </el-dialog>
    <watermark v-if="showWater"></watermark>
    <anchorBox></anchorBox>
</div>
</template>

<script>
import topNav from "@/components/common/topNav";
import Header from "@/components/common/header";
import anchorBox from "@/components/common/anchorBox";
import copyright from "@/components/common/copyright";
import columnNav from "@/components/common/columnNav";
import contact from "@/components/common/contact";
import crumbs from "@/components/crumbs";
import recomment from "@/views/preview/components/recomm";
import {
    auctionarr,
    agencyarr,
    special,
    onlineAuction,
    setBidClick,
    getMeeting,
    captchaGenerate,
    captchaVerify
} from "@/api/auction";
import {
    gotoSpec
} from "@/api/spec";
import EmptyPage from "@/components/common/emptyPage";
import watermark from "@/components/common/watermark";
import AdvImage from "@/components/advert/advImage";
import AdvLamu from "@/components/advert/advLamu";
import lottie from '@/components/common/lottie'
import {
    mapActions,
    mapGetters
} from 'vuex';
import {
    sendScData
} from "@/utils/buriedPoint";
const liveIcon = require('@/assets/imgs/live_icon_2.json')
const liveIcon2 = require('@/assets/imgs/live_icon_3.json')
export default {
    name: "meeting_detail",
    components: {
        lottie,
        recomment,
        crumbs,
        columnNav,
        Header,
        copyright,
        topNav,
        EmptyPage,
        anchorBox,
        watermark,
        AdvImage,
        AdvLamu,
        contact
    },
    data() {
        return {
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            heartOptions2: {
                animationData: liveIcon2,
                loop: true,
                autoplay: true,
            },
            verify: "",
            verifyImg: "",
            verifyFlag: false,
            showWater: this.$route.query.from ? true : false,
            fromId: this.$route.query.from || '',
            bulletin: "",
            jumpVal: 1,
            result: [],
            showPop: false,
            msgTips: '',
            showCode: false,
            showLicense: false,
            crumbs: [{
                    name: "雅昌拍卖首页",
                    path: "/",
                },
                {
                    name: "雅昌拍卖预展",
                    path: "/preauction",
                },
                {
                    name: "中国书画拍卖会",
                    path: "/",
                },
            ],
            inputLog: "",
            params: {
                //拍卖会参数
                sessionCode: "",
            },
            specialParam: {
                session_code: "",
                status: 5, //参数全部显示
                order: 0, //日期显示0 不按照日期排序 2降序 3升序
                page_size: 999
            },
            organ: {
                //机构参数
                organCode: "",
                language: "zh-CN",
            },
            session: {
                session_code: "",
            },
            currentPage: 1, //当前页面
            name: "", //拍卖会名字
            detailExtraInfo: [], //拍卖会信息
            extraInfo: [], //预展
            arr: {}, //机构
            specialsList: [], //专场详情
            sessionList: [], //拍品推荐
            detailInfo: [],
            license: "",
            isLogin: 0,
            status: 0,
            isLoading: false,
            onlineUrl: '',
            isShowOnline: false,
            onlinePerson: 0,
            info: null
        };
    },
    asyncData({
        store,
        route
    }) {
        let params = {
            sessionCode: route.params.id,
            only_meta: 1
        }
        if (route.query.from && route.query.from == 1) {
            params.show = 1
            params.session_inspect_id = route.query.sessiion_inspect_id
        }
        return store.dispatch("pageMeetingDetail/getMeetingDetail", [params, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageMeetingDetail/getIsLoadIng",
            getData: "pageMeetingDetail/getData",
        }),
    },
    mounted() {
        if (!this.getIsLoadIng) {
            let parmas = {
                sessionCode: this.$route.params.id,
                only_meta: 1
            }
            if (this.$route.query.form && this.$route.query.form == 1) {
                parmas.show = 1;
                parmas.session_inspect_id = this.$route.query.sessiion_inspect_id;
            }
            this.getMeetingDetail([parmas, () => {
                this.filteData();
            }])
        } else {
            this.filteData();
        }
        this.getAuctionarr();
        this.getSpecial();
        this.getGenerate();

        window.scroll({
            top: 0,
            left: 0
        })
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }
    },
    methods: {
        ...mapActions({
            getMeetingDetail: "pageMeetingDetail/getMeetingDetail"
        }),
        openLicense() {
            this.showLicense = true
        },
        getGenerate() {
            captchaGenerate().then((res) => {
                this.verifyImg = res.data.data;
                this.captchaId = res.data.captchaId;

            })
        },
        jumpLink(e) {
            window.location.href = window.location.protocol + '//' + e
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        subVerify() {
            captchaVerify({
                verifyCode: this.verify,
                captchaId: this.captchaId
            }).then((res) => {
                if (res.code == 0) {
                    this.verifyFlag = true
                } else {
                    this.$message({
                        message: res.message
                    });
                }

            })
        },
        getMeetDetail() {
            getMeeting({
                organCode: this.info.organ_code,
                sign: new Date().getFullYear(),
                only_meta: 0
            }).then((res) => {
                if (res.code == 0) {
                    // this.meetName = res.data.name;
                    this.detailInfo = res.data.detailExtraInfo;
                    // this.msg = res.data.clause
                    this.license = res.data.license
                }
            });
        },
        filteData() {
            let data = this.$store.state["pageMeetingDetail"]["data"]
            let that = this;
            if (!data.meta.title) {
                this.$message({
                    message: '该内容不存在～',
                    onClose() {
                        that.$router.push({
                            path: '/'
                        })
                    }
                });
                return false
            }
            this.info = data
            this.name = data.name;
            this.crumbs[2].name = this.name
            this.detailExtraInfo = data.detailExtraInfo;
            this.extraInfo = data.extraInfo;
            // this.isLogin = data.isLogin
            this.status = data.status
            this.crumbs[1].name = data.status == 5 ? '雅昌拍卖预展' : '雅昌拍卖结果'
            this.crumbs[1].path = data.status == 5 ? '/preauction' : '/result'
            this.crumbs[2].name = data.name
            this.crumbs[2].path = '/meeting_detail/' + this.$route.params.id
            // 公告切换出来
            this.detailExtraInfo.map((value) => {
                switch (value.label) {
                    case '说明':
                        that.bulletin = value.text.replace('\n', '<br/>')
                        break
                    case '拍卖公司':
                        that.getAgencyarr(value.organCode);
                        break
                }
            });
            this.isLoading = false
            this.getMeetDetail();

            // 设置高度
        },
        // 正常排序
        defaultClick() {
            this.specialParam.order = 3;
            this.getSpecial();
        },
        // 日期升序
        ascen() {
            this.specialParam.order = 2;
            this.getSpecial();
        },
        // 日期降序
        descen() {
            this.specialParam.order = 3;
            this.getSpecial();
        },
        changeNum() {
            // 不能显示负数 不能等于0 否则等于1
            this.jumpVal =
                Number(this.jumpVal) <= 0 || !Number(this.jumpVal) ?
                1 :
                this.jumpVal;
            this.jumpVal =
                // 判断不能超过总页码  超过则显示最大值
                this.jumpVal > Math.ceil(this.specialsList.length / 6) ?
                Math.ceil(this.specialsList.length / 6) :
                this.jumpVal;
            this.currentPage = this.jumpVal;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = Number(val);
        },
        // 跳转拍卖专场页面
        jumpSpecialC(item) {
            let flag = true
            if (this.$route.query.from == 1) {
                return false
            }
            let infoArr = item.pc_extra_info
            infoArr.forEach((con) => {
                if (con.type == 'total' && con.text == '0') {
                    flag = false
                    return false
                }
            });
            if (flag) {
                let fromLink = this.$route.query.from == 2 ? '?from=2' : ''
                window.open('/special_detail/' + item.specialCode + fromLink)
            }

        },
        gotoLogin() {
            if (this.$route.query.from) {
                return false
            }
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        // 拍卖会
        getAuctionarr() {
            this.params.sessionCode = this.$route.params.id;
            this.params.only_meta = 0;
            // this.params.sessionCode = 'PMH212566';
            auctionarr(this.params).then((res) => {
                if (res.code == 0) {
                    this.name = res.data.name;
                    this.crumbs[2].name = this.name
                    this.detailExtraInfo = res.data.detailExtraInfo;
                    this.extraInfo = res.data.extraInfo;
                    // 公告切换出来
                    var that = this;
                    this.detailExtraInfo.map((value) => {
                        if (value.label == '说明') {
                            that.bulletin = value.text.replace(/\n/g, '<br/>')
                        }
                    });

                    if (res.data.catalog_info_new && res.data.catalog_info_new.length) {
                        let catalog = res.data.catalog_info_new[0];
                        this.isShowOnline = true;
                        this.onlineUrl = catalog.link;
                        this.onlinePerson = res.data.bid_click_num;
                    }
                }else{
                    this.$message.error(res.message)
                    setTimeout(()=>{
                        this.$router.push({
                            path:'/'
                        })
                    },1000)
                }
            });
        },
        //拍卖专场
        getSpecial() {
            this.specialParam.session_code = this.$route.params.id;
            // this.specialParam.session_code = "PMH212566";
            special(this.specialParam).then((res) => {
                this.result = [];
                if (res.code == 0) {
                    this.specialsList = res.data.list;

                    if (this.specialsList) {
                        var chunk = 999; //每3个分一组

                        for (
                            var i = 0, j = this.specialsList.length; i < j; i += chunk
                        ) {
                            this.result.push(
                                this.specialsList.slice(i, i + chunk)
                            );
                        }
                    }
                }
            });
        },
        gotoSpecial() {
            if (!this.result.length) {
                return false
            }
            if (this.$route.query.form == 1) {
                return false
            }
            let params = {
                showType: 1,
                keyword: this.inputLog,
                session_code: this.$route.params.id
            }
            gotoSpec(params).then((res) => {
                if (res.code == 0) {
                    if (!res.data.list.length) {
                        this.showPop = true
                        this.msgTips = '没有搜索到相关拍品，请重新输入'
                        this.inputLog = ''
                    } else {
                        // let speCode = res.data.list[0].ArtCode
                        this.$router.push({

                            path: '/paimai-' + res.data.list[0].ArtCode
                            // name:'special_detail',
                            // params:{
                            //     id:speCode,
                            // },
                            // query:{
                            //     lot:this.inputLog
                            // }
                        })
                    }
                }
            })
        },
        closePop() {
            this.inputLog = ''
            this.msgTips = ''
            this.showPop = false
        },
        // 拍卖机构
        getAgencyarr(code) {
            this.organ.organCode = code;
            agencyarr(this.organ).then((res) => {
                if (res.code == 0) {
                    this.arr = res.data;
                    sendScData('auction', {
                        the_auction_id: this.$route.params.id,
                        the_auction_name: this.name,
                        auction_company: this.arr.SimpleName
                    })
                }
            });
        },

        onlineClick() {
            let params = {
                specialCode: this.$route.params.id,
            }
            setBidClick(params).then(res => {
                if (res.code == 0) {
                    // this.onlinePerson = res.data.bid_click_num;
                }
            });
            setTimeout(() => {
                window.location.href = this.onlineUrl;
            }, 500)

        },
    },
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");

/deep/ .el-carousel__arrow {
    display: none;
}

// 输入框样式
/deep/ .el-input__inner {
    border-color: #dcdfe6;
    height: 24px;
}

/deep/ .el-input__inner:hover {
    border-color: #329d15;
}

.licenseBox {
    width: 100%;
    height: 70vh;

    img {
        height: 100%;
        object-fit: contain;
    }
}

.verifyBox {
    width: 50%;
    margin: auto;
    padding: 5rem 77px;
    text-align: center;
    .verifyInput{
        margin-top: 1rem;
        height: 40px;
        /deep/.el-input__inner{
            height: 40px;
        }
    }

    .btn {
        background: #009B5F;
        margin-top: 1rem;
        font-size: 16px;
        line-height: 40px;
        font-weight: 600;
        color: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
    }


    img {
        margin: 1rem 0;
        background: #eee;
        border-radius: 8px 8px 8px 8px;
    }

    span {
        display: block;
    }
}

.ai-info-box {
    width: 1180px;
    overflow: hidden;
    word-wrap: break-word;
    word-break: normal;
}

.meeting_detail {
    background: #ffffff;
    margin: 0 auto;
}

.tel {
    width: 1180px;
    height: 40px;
    background: #eaf5e7;
    border-radius: 4px;
    border: 1px solid #329d15;
    flex: 1;
}

.little-green {
    width: 16px;
    height: 16px;
    background: #329d15;
    border-radius: 8px;
    text-align: center;
    line-height: 10px;
    float: left;
    margin: 12px 0 12px 20px;
}

.el-icon-phone {
    width: 16px;
    height: 16px;
    color: #ffffff;
    font-size: 8px;
    line-height: 16px;
    text-align: center;
}

.tel-font {
    display: inline-block;
    width: 214px;
    height: 22px;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #329d15;
    line-height: 22px;
    margin: 9px 0 9px 10px;
}

.auction-info {
    margin-top: 30px;
}

.ai-box {
    // height: 344px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    height: 100%;
    padding-bottom: 20px;
}

.ai-box1 {
    // height: 320px;
    padding-bottom: 20px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    margin-top: 30px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #262626;
}

.big-title {
    margin-top: 21px;
}

.green-piece {
    width: 10px;
    height: 30px;
    display: inline-block;
    background: #329d15;
}

.big-title-font {
    width: 530px;
    display: inline-block;
    font-size: 24px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #262626;
    line-height: 32px;
    padding-left: 20px;
    overflow: hidden;

    img {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        border-radius: 50px;
    }
}

.gray-title {
    height: 30px;
    background: linear-gradient(270deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.05) 100%);
    margin-top: 20px;
}

.gray-title-font {
    height: 30px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 30px;
    margin-left: 30px;
}

span {
    vertical-align: middle;
}

.ai-info {
    margin-top: 20px;
    margin-left: 30px;
}

.ai-info-p {
    padding-top: 4px;
    line-height: 22px;
}

.ai-info-p-add {
    line-height: 17px;
    display: flex;
}

.ai-info-title {
    display: inline-block;
    height: 22px;
    font-size: 14px;
    float: left;
    font-family: MicrosoftYaHei;
    color: #8c8c8c;
    line-height: 22px;
    width: 56px;
}

.ai-info-font {
    display: inline-block;
    width: 467px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 22px;
    position: relative;
}

.ai-info-font-adress {
    display: -webkit-box;
    width: 250px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #8C8C8C;
    line-height: 17px;
    word-break: break-all;
    max-height: 66px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ai-info-guanggao {
    margin: 10px 30px;
}

.ai-info-font-guanggao {
    font-size: 14px;
    //text-indent: 2rem;
    line-height: 30px;
    font-family: MicrosoftYaHei;
    color: #262626;
    // width: 1180px;
    word-wrap: break-word;
    word-break: normal;
}

.special-info {
    height: 60px;
    background: #fafafa;
    border: 1px solid #d9d9d9;
    margin-top: 30px;
    line-height: 60px;
}

.si-title {
    height: 60px;
    display: inline-block;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 60px;
    margin-left: 20px;
}

.default {
    height: 60px;
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 60px;
    margin-left: 40px;
}

.default:hover {
    cursor: pointer;
}

.si-green {
    height: 60px;
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #329d15;
    line-height: 60px;
    margin-left: 40px;
}

.si-font {
    height: 60px;
    display: inline-block;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 60px;
    margin-left: 40px;
}

.si-input {
    width: 180px;
    height: 30px;
    margin-left: 40px;
}

.si-gray {
    height: 60px;
    display: inline-block;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #595959;
    line-height: 60px;
    margin-left: 40px;
}

//直播
.el-col-12 {
    padding-left: 0px !important;
    padding-right: 0px !important;
    margin-right: 20px;
    width: 580px;
    float: none;
}

.el-col-12:nth-child(2n) {
    padding-left: 0px;
    margin-right: 0;
}

.live-box {
    min-height: 280px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
    position: relative;
}

.live-box:hover {
    cursor: pointer;
}

.live-pic {
    width: 100%;
    display: inline-block;
    border-radius: 4px 0 0 4px;
    overflow: hidden;
    margin: -1px 0 0 -1px;
    position: relative;

    /deep/.el-image__inner {
        object-fit: cover;
    }

    .liveIcon {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 3;
        font-size: 12px;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 0.2);
        padding: 4px 10px;
        border-radius: 25px 25px 25px 25px;

        .liveIconSty {
            display: inline-block;
            vertical-align: middle;
            margin-right: 0.2rem;
            background: #f6344b;
            border-radius: 25px;
            padding: 6px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.live-pic-green {
    width: 210px;
    height: 40px;
    background: rgba(50, 157, 21, 0.85);
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    transition: .2s background-color ease-in-out;
}

.live-pic-black {
    width: 210px;
    height: 40px;
    background: rgba(0, 0, 0, 0.85);
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    transition: .2s background ease-in-out;
}

.hoverBg {
    position: absolute;
    width: 210px;
    height: 40px;
    bottom: 0;
    display: block;
}

.hoverBg:hover .live-pic-green {
    background: rgba(50, 157, 21, 1);
}

.hoverBg:hover .live-pic-black {
    background: rgba(0, 0, 0, 1);
}

.live-little-box {
    margin-top: 10px;
    min-height: 130px;
    position: relative;
}

.llb-title {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 26px;
    font-weight: bold;
}

.llb-title:hover {
    color: #329d15;
}

.llb-title:active {
    color: #329d15;
}

.llb-bubble {
    margin-top: 5px;
}

.llb-bubbles {
    height: 20px;
    display: inline-block;
    font-size: 11px;
    font-family: MicrosoftYaHei;
    color: #999;
    background: rgba(140, 140, 140, 0.08);
    line-height: 20px;
    border-radius: 4px;
    padding: 0 4px;
    margin-right: 10px;
}

.llb-info {
    margin-top: 20px;
}

.llb-info-add {
    margin-top: 10px;
}

.llb-info-title {
    height: 17px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #8c8c8c;
    line-height: 17px;
    vertical-align: top;
}

.llb-browse {
    height: 22px;
    line-height: 22px;
    // position: absolute;
    // top: 240px;
}

.llb-browse-font {
    margin-left: 6px;
    height: 22px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #262626;
    line-height: 22px;
}

.paging {
    width: 1180px;
    margin: 40px auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    /deep/ .el-pagination {
        display: inline-block;
        text-align: center;

        button {
            padding: 0 10px;
            line-height: 28px;
            border: 1px solid #bfbfbf;
            border-radius: 4px;
            background-color: transparent;
            color: #262626;
        }

        .el-pager {
            font-size: 0;

            li {
                padding: 0 10px;
                line-height: 28px;
                border: 1px solid #bfbfbf;
                border-radius: 4px;
                background-color: transparent;
                transition: 0.2s all ease-in-out;
                font-weight: normal;
            }

            li:hover,
            .active,
            .el-pagination.is-background .el-pager li:not(.disabled).active {
                border-color: #329d15;
                background-color: #eaf5e7;
                color: #329d15;
            }

            .more {
                border: 0;
            }
        }
    }

    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        border-color: #329d15;
        background-color: #eaf5e7;
        color: #329d15;
    }

    .total {
        font-size: 14px;
        color: #595959;
        margin: 0 20px 0 15px;

        i {
            color: #329d15;
        }
    }

    .jumpBox {
        display: inline-block;
        line-height: 30px;
        color: #595959;
        font-size: 14px;

        .inputJump {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid #bfbfbf;
            text-align: center;
            color: #595959;
            margin: 0 2px;
        }
    }
}

.el-row {
    display: flex;
}

.live-info .el-row {
    display: block;
    overflow: hidden;
}

.live-info .el-col-12 {
    float: left;
}

/deep/.el-button--primary {
    background-color: #329d15
}

/deep/.el-dialog__body {
    text-align: center;
}

.auctionView {
    width: 280px;
    height: 40px;
    background: #329D15;
    border-radius: 4px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 37px;
    text-align: center;
    display: block;
    margin-left: 20px;
    cursor: pointer;

    &:hover {
        color: #ffffff;
        text-decoration: none;
    }

    .line {
        width: 1px;
        height: 12px;
        opacity: 0.4;
        border: 1px solid #FFFFFF;
        display: inline-block;
        margin: 0 15px;
        margin-top: -4px;
    }

    i {
        background: url(../../assets/imgs/icon_portrait.png) no-repeat center center;
        background-size: 100% 100%;
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        vertical-align: middle;
        margin-top: -3px;
    }
}

.codeBox {
    position: absolute;
    padding: 10px;
    background: #FFFFFF;
    display: block;
    text-align: center;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    line-height: 20px;
    font-size: 12px;
    color: #8C8C8C;
    top: 32px;

    img {
        width: 78px;
        height: 78px;
        margin-bottom: 10px;
    }
}
</style>
